/** Remove cookies visible to this page across possible paths and parent domains. */
export function clearAccessibleCookies() {
  const names = document.cookie.split(';').map(cookie => cookie.trim().split('=')[0]).filter(Boolean);
  const segments = window.location.pathname.split('/').filter(Boolean);
  const paths = ['/'];
  for (let i = 1; i <= segments.length; i++) {
    const path = `/${segments.slice(0, i).join('/')}`;
    paths.push(path, `${path}/`);
  }
  const labels = window.location.hostname.split('.');
  const domains = [''];
  for (let i = 0; i < labels.length - 1; i++) domains.push(`; domain=${labels.slice(i).join('.')}`);
  for (const name of names) {
    for (const path of paths) {
      for (const domain of domains) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${domain}`;
      }
    }
  }
}
